import React from "react";

//Utils
import { mapServices } from "../../../Utils/Utils";

//Images
import driveways from "../images/services/services-driveways.jpg";
import patios from "../images/services/services-patios.jpg";
import pools from "../images/services/services-pools.jpg";
import gardenWalls from "../images/services/services-garden-walls.jpg";
import steps from "../images/services/services-steps-and-coping.jpg";
import walkways from "../images/services/services-walkways.jpg";
// import firefeatures from "../images/services/services-firefeatures.jpg";

const Services = () => {
  const services = [
    {
      title: "Patios",
      image: patios,
      destination: "/services/patios",
    },
    {
      title: "Driveways",
      image: driveways,
      destination: "/services/driveways",
    },
    {
      title: "Garden Walls",
      image: gardenWalls,
      destination: "/services/garden-walls",
    },
    {
      title: "Pool Decks",
      image: pools,
      destination: "/services/pool-decks",
    },
    {
      title: "Steps and Coping",
      image: steps,
      destination: "/services/steps-and-coping",
    },
    {
      title: "Walkways",
      image: walkways,
      destination: "/services/walkways",
    },
    // {
    //   title: "Fire Features",
    //   image: firefeatures,
    //   destination: "/services/firefeatures",
    // },
  ];

  return (
    <div className="row justify-content-center">
      <div className="col-11 col-xl-10 no-side-padding panel-services">
        <div className="row justify-content-center">
          <div className="col-6 col-md-4 col-lg-3 mb-3 text-center">
            <h3 className="text-uppercase text-blue">Services</h3>
          </div>
        </div>
        <div className="row justify-content-center services-list">
          {mapServices(services)}
        </div>
      </div>
    </div>
  );
};

export default Services;
